<template>
  <layout-basic>
    <v-container grid-list-md text-xs-center fluid>
      <v-layout row wrap>
        <v-flex
          v-for="(item, index) in topRow"
          :key="`top-${index}`"
          xs3
          class="pa-4"
        >
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :to="item.link"
              :class="`elevation-${hover ? 12 : 2}`"
              class="mx-auto"
            >
              <v-card-text class="px-0 admin-button">
                <v-img
                  :src="item.icon"
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  class="unpixelate"
                ></v-img>
                <h3>{{ item.text }}</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex
          v-for="(item, index) in bottomRow"
          :key="`bottom-${index}`"
          xs3
          class="pa-4"
        >
          <v-hover>
            <v-card
              v-if="item.link != null"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              class="mx-auto"
              :to="item.link"
              @click="openWidget"
            >
              <v-card-text class="px-0 admin-button">
                <v-img
                  :src="item.icon"
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  class="unpixelate"
                ></v-img>
                <h3>{{ item.text }}</h3>
              </v-card-text>
            </v-card>
            <v-card
              v-else
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              class="mx-auto"
              @click="openWidget"
            >
              <v-card-text class="px-0 admin-button">
                <v-img
                  :src="item.icon"
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  class="unpixelate"
                ></v-img>
                <h3>{{ item.text }}</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs3 class="pa-4">
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              class="mx-auto"
              @click="openWidget"
            >
              <v-card-text class="px-0 admin-button">
                <v-img
                  :src="item.icon"
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  class="unpixelate"
                ></v-img>
                <h3>He</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
export default {
  components: {
    LayoutBasic
  },
  data() {
    return {
      topRow: [
        {
          text: "Users",
          icon: "/static/admin-icons/Web_Icon_Users_Blue.png",
          link: "/admin/users",
          disabled: false
        },
        {
          text: "Courses",
          icon: "/static/admin-icons/Web_Icon_Courses_Green.png",
          link: "/admin/courses",
          disabled: false
        },
        {
          text: "Playlists",
          icon: "/static/admin-icons/Web_Icon_Channels_Purple.png",
          link: "/admin/playlists",
          disabled: false
        },
        {
          text: "Groups",
          icon: "/static/admin-icons/Web_Icon_Groups_LightBlue.png",
          link: "/admin/groups",
          disabled: false
        }
      ],
      bottomRow: [
        {
          text: "Reports",
          icon: "/static/admin-icons/Web_Icon_Reports_Red.png",
          link: "/admin/reports",
          disabled: true
        }
        /*,
        {
          text: "Finance & Account",
          icon: "/static/admin-icons/Web_Icon_Finance_VibrantGreen.png",
          link: "/admin/finance",
          disabled: true
        },
        {
          text: "Marketplace",
          icon: "/static/admin-icons/Web_Icon_MarketPlace_Yellow.png",
          link: "/admin/marketplace",
          disabled: false
        },
        {
          text: "Help",
          icon: "/static/admin-icons/Web_Icon_Help.png",
          link: null,
          disabled: false
        }*/
      ]
    };
  },
  mounted() {
    // if (this.$store.getters.level == 4) {
    //   window.addEventListener
    //     ? window.addEventListener("load", this.initiateCall(), !1)
    //     : window.attachEvent("load", this.initiateCall(), !1);
    // }
    // window.fcWidget.hide();
  },
  methods: {
    // initFreshChat() {
    //   window.fcWidget.init({
    //     token: "4c92e035-db9f-4403-985c-9170ed83bd69",
    //     host: "https://wchat.freshchat.com",
    //     externalId: this.$store.getters.user.id,
    //     firstName: this.$store.getters.user.first_name,
    //     lastName: this.$store.getters.user.last_name,
    //     config: {
    //       cssNames: {
    //         widget: "custom_fc_frame"
    //       }
    //     }
    //   });
    //   //window.fcWidget.hide();
    // },
    // initialize(i, t) {
    //   var e;
    //   i.getElementById(t)
    //     ? this.initFreshChat()
    //     : (((e = i.createElement("script")).id = t),
    //       (e.async = !0),
    //       (e.src = "https://wchat.freshchat.com/js/widget.js"),
    //       (e.onload = this.initFreshChat),
    //       i.head.appendChild(e));
    // },
    // initiateCall() {
    //   this.initialize(document, "freshchat-js-sdk");
    //   window.fcWidget.hide();
    // },
    openWidget() {
      // window.fcWidget.open();
      // window.fcWidget.show();
    }
  }
};
</script>
<style scoped>
.unpixelate {
  -webkit-transform: initial;
}
</style>
